<template>
  <div class="w-100">
    <v-progress-linear
      v-if="(info && loadingPage) || loading"
      indeterminate
      color="cyan"
      class="w-100 my-5"
    ></v-progress-linear>
    <v-card v-else elevation="0">
      <v-card-title> افزودن هشتگ (دسته بندی ها) </v-card-title>
      <v-col cols="12">
        <v-text-field
          ref="phoneAdd"
          v-model="hashtagText"
          :loading="loading"
          :rules="[(v) => !!v || 'محتوای باکس نمیتواند خالی باشد']"
          type="text"
          class="me-md-2"
          dense
          hide-details
          outlined
          prepend-inner-icon="mdi-pound"
          @keydown.enter="addHashtags"
        >
          <template v-slot:append>
            <div
              style="cursor: pointer"
              @click="addHashtags"
              id="showHand"
              class="text-primary d-flex"
            >
              <v-icon color="blue">mdi-plus-box</v-icon>
              <span class="d-md-block small my-auto"> افزودن</span>
            </div>
          </template>
        </v-text-field>
      </v-col>

      <v-col v-if="inputs.length > 3" class="d-flex align-center">
        <v-text-field
          v-model="search"
          label="جستجو در هشتگ ها"
          append-icon="search"
          clearable
          dense
          hide-details
          outlined
        >
          <template v-slot:append>
            <v-icon>mdi-search</v-icon>
          </template>
        </v-text-field>
        <v-menu left offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="btn-delete ma-0 ms-2" v-bind="attrs" v-on="on">
              <v-icon left>mdi-delete-sweep</v-icon>
              حذف
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list class="rounded">
            <v-list-item class="justify-center">
              <v-btn
                @click="deleteAllHashtag"
                block
                class="btn-delete"
                style="border-radius: 0"
              >
                حذف هشتگ ها
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-card-subtitle v-if="inputs.length > 0">
        {{ search ? "هشتگ های جستجو شده" : "هشتگ های انتخابی " }}
      </v-card-subtitle>
      <v-col
        cols="12"
        style="gap: 1rem"
        class="d-flex flex-wrap justify-center"
      >
        <HashtagCell
          v-for="i in search.length > 0 ? searchInput : inputs"
          :key="i"
          v-model="i.name"
          :obj="i"
          @delete="deleteHashtag"
          @show="editShow"
          :admin="admin"
          :checkInput="checkInput"
        />
        <v-card-subtitle
          v-if="
            search.length > 0 ? searchInput.length == 0 : inputs.length == 0
          "
        >
          هشتگی برای نمایش وجود ندارد
        </v-card-subtitle>
      </v-col>

      <v-card-title> افزودن تصویر</v-card-title>
      <v-card-subtitle
        >عکس های انتخابی جهت نمایش کیوآر شما در مجتمع تجاری است</v-card-subtitle
      >
      <v-col>
        <!-- <bannerSelector :value="gallery" /> -->
        <pic-selector
          v-model="gallery"
          :edit-name="false"
          default-cat-name="بنر"
          single
        />
      </v-col>

      <v-card-actions>
        <v-btn @click="changeShowApi" class="w-100" outlined color="green">
          <v-icon size="20">mdi-plus</v-icon>
          افزودن تغییرات جدید
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import HashtagCell from "./HashtagCell.vue";
import picSelector from "../../UploadCenter/picSelector.vue";
import bannerSelector from "../../UploadCenter/bannerSelector.vue";
export default {
  components: { HashtagCell, bannerSelector, picSelector },
  props: {
    loadingPage: Boolean,
    info: Object,
    admin: Boolean,
    qrland: String,
    update: Function,
  },
  data() {
    return {
      hashtagText: "",
      search: "",
      inputs: [],
      searchInput: [],
      gallery: [{ name: "", images: [] }],
      loading: false,
    };
  },

  methods: {
    addHashtags() {
      if (this.hashtagText.length > 0) {
        const find = this.inputs.find((item) => item.name === this.hashtagText);
        if (find) {
          this.$toast.error("نمیتوانید هشتگ تکراری اضافه کنید");
        } else {
          this.inputs.push({
            name: this.hashtagText.toLowerCase(),
            show: true,
            id: this.inputs.length + 1,
          });
          this.$toast.success("هشتگ با موفقیت اضافه شد");
          this.hashtagText = "";
        }
      } else {
        this.$toast.error("مقدار هشتگ نمیتواند خالی باشد");
      }
    },
    async deleteHashtag(i) {
      if (
        await this.$modal.yesNo(
          `آیا از حذف هشتگ " ${this.inputs[i - 1].name} " خود اطمینان دارید`,
        )
      ) {
        this.inputs = this.inputs.filter((item) => item.id !== i);
      } else return;
    },
    checkInput(text) {
      const find = this.inputs.find((item) => item.name === text);
      if (find) return false;

      return true;
    },
    async deleteAllHashtag() {
      if (
        await this.$modal.yesNo("آیا از حذف همه هشتگ های خود اطمینان دارید؟")
      ) {
        this.inputs = [];
        this.$toast.success("تمامی هشتگ های پاک شد");
      }
    },
    updateGallery(newValue) {
      this.gallery = newValue; // آپدیت گالری با عکس‌ها و تایتل‌ها
    },
    async changeShowApi() {
      this.loading = true;
      const newUpdate = {
        ...this.info,
        images: this.gallery[0].images,
        tags: this.inputs,
      };
      try {
        await this.$api.put(`v1/commercial/${this.qrland}`, newUpdate);
        await this.update();
        this.$toast.success("تغییرات شما با موفقیت اعمال شد");
      } catch (err) {
        this.$toast.error("مشکلی پیش آمده است لطفا دوباره تلاش کنید");
      } finally {
        this.loading = false;
      }
    },
    async editShow(id) {
      if (
        await this.$modal.yesNo("آیا از تغییر وضعیت نمایش هشتگ اطمینان دارید؟")
      ) {
        this.inputs = this.inputs.map((item) => {
          if (item.id == id) {
            return { ...item, show: !item.show };
          } else {
            return item;
          }
        });
        this.$toast.success("وضعیت هشتگ تغییر کرد");
      } else {
        return;
      }
    },
  },

  watch: {
    info: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val) return; // اگر مقدار undefined بود کلاً بیرون بزن

        // بعد ادامه کار با خیال راحت
        if (val.images !== this.gallery[0].images) {
          this.$set(this.gallery[0], "images", val.images || []);
        }
        if (JSON.stringify(val.tags) !== JSON.stringify(this.inputs)) {
          this.inputs = val.tags ? [...val.tags] : [];
        }
      },
    },
    search: {
      deep: true,
      handler(val) {
        if (val) {
          this.searchInput = this.inputs.filter((item) =>
            item.name.includes(val.toLowerCase()),
          );
        } else {
          this.searchInput = [];
        }
      },
    },
  },
};
</script>

<style></style>
